import React from 'react'

import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Tooltip } from 'primereact/tooltip';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { AuthContext } from '../../main/ProvedorAutenticacao'

import Navbar from '../../componentes/Navbar'
import ConfiguracaoTarefaService from '../../app/service/ConfiguracaoTarefaService'

import './ConfiguracaoTarefa.css'

class ConfiguracaoTarefa extends React.Component {
  constructor(props) {
    super(props);

    this.configuracaoTarefaService = new ConfiguracaoTarefaService();

    this.subTarefas = this.subTarefas.bind(this);
    this.renderSubTarefas = this.renderSubTarefas.bind(this);
    this.acoesTarefas = this.acoesTarefas.bind(this);
    this.acoesDesvincular = this.acoesDesvincular.bind(this);
    this.renderNovaConfiguracao = this.renderNovaConfiguracao.bind(this);
    this.renderAlterarConfiguracao = this.renderAlterarConfiguracao.bind(this);
    this.renderNovaConfiguracaoSub = this.renderNovaConfiguracaoSub.bind(this);
    this.acceptDesvincularTarefa = this.acceptDesvincularTarefa.bind(this);

    this.state = {
      tarefas: [],
      tarefa: null,
      codigo: '',
      nome: '',
      nomeConsulta: '',
      snCriaOutraTarefa: '',
      criaOutraTarefa: null,
      tarefaCriadora: null,
      prazoData: '',
      tituloCriada: '',
      ponto: '',
      snAtivo: '',
      status: null,
      tarefasFilhas: [],
      openSpinner: false,
      modalNovaConfiguracao: false,
      modalNovaSubTarefa: false,
      modalSubTarefas: null,
      configuracoesSemTarefas: [],
      configuracoesSemTarefa: null,
      modalAlterarConfiguracao: false
    }

    this.status = [
      {codigo: 'ATIVO', nome: 'ATIVO'},
      {codigo: 'INATIVO', nome: 'INATIVO'}
    ];

    this.criaOutraTarefa = [
      {codigo: 'S', nome: 'SIM'},
      {codigo: 'N', nome: 'NÃO'}
    ]
  }

  listarTarefas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.configuracaoTarefaService.listarTarefas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tarefas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesTarefas(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-plus" 
                className="p-button-rounded p-button-text"
                tooltip="Incluir tarefa associada"
                onClick={() => this.consultarConfiguracaoTarefa(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="fa fa-solid fa-pen" 
                className="p-button-rounded p-button-text"
                tooltip="Editar Configuração"
                onClick={() => this.consultarConfiguracaoTarefaEditar(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="fa fa-solid fa-trash" 
                className="p-button-rounded p-button-text"
                tooltip="Excluir Configuração"
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  acoesDesvincular(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-solid fa-trash" 
                className="p-button-rounded p-button-text"
                onClick={() => this.confirmaDesvincularTarefa(rowData)}
                tooltip="Desvincular Configuração"
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  confirmaDesvincularTarefa(tarefa) {
    this.setState({codigo: tarefa.codigo});
    confirmDialog({
        message: 'Deseja realmente desvincular esta tarefa da principal ?',
        header: 'Desvincular Tarefa',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptDesvincularTarefa,
        reject: this.reject
    });
  }

  acceptDesvincularTarefa() {
    this.desvincularTarefa();
  }

  subTarefas(rowData) {
    var subTarefas = rowData.tarefasFilhas.length;
    var exibe = 'none';
    if(subTarefas > 0) {
      exibe = 'block';
    }
    return(
      <React.Fragment>
        <a onClick={() => this.consultarSubTarefas(rowData)}
           title="Clique aqui para ver as tarefas geradas a partir desta"
           style={{cursor: 'pointer', display: `${exibe}`, color: 'blue', alignItems: 'center'}}>{subTarefas}</a>
      </React.Fragment>
    );
  }

  renderSubTarefas(name) {
    return (
        <div>
            <Button label="Incluir nova Sub-Tarefa" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTipo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderNovaConfiguracao(name) {
    return (
      <div>
        <Button label="Cadastrar" 
                onClick={this.cadastrarNovaConfiguracao}
                className="p-button-primary p-button-text"/> 
        &nbsp;
        <Button label="Cancelar" 
                className="p-button-secondary p-button-text"
                onClick={() => this.fecharModal(name)}/>
      </div>
    );
  }

  renderAlterarConfiguracao(name) {
    return (
      <div>
        <Button label="Alterar" 
                onClick={this.alterarConfiguracaoTarefa}
                className="p-button-primary p-button-text"/> 
        &nbsp;
        <Button label="Cancelar" 
                className="p-button-secondary p-button-text"
                onClick={() => this.fecharModal(name)}/>
      </div>
    );
  }

  alterarConfiguracaoTarefa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:'Informe o nome da configuração da tarefa', life: 4000});
      return;
    }

    var ativo = 'S';
    if(this.state.status.codigo == 'ATIVO') {
      ativo = 'S'
    } else {
      ativo = 'N'
    }

    const tarefa = {
      codigo: this.state.tarefa.codigo,
      nome: this.state.nome,
      tituloCriada: this.state.tituloCriada,
      snCriaOutraTarefa: this.state.criaOutraTarefa.codigo,
      snAtivo: ativo,
      tarefaCriadora: this.state.tarefa.tarefaCriadora,
      prazoData: this.state.prazoData,
      ponto: this.state.ponto,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    await this.configuracaoTarefaService.alterarConfiguracaotarefa(tarefa)
      .then(response => {
        this.listarTarefas();
        this.toast.show({severity:'success', summary: 'Configuração de Tarefa', detail:'Configuração de tarefa alterada com sucesso', life: 4000});
        this.fecharModal('modalAlterarConfiguracao');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  renderNovaConfiguracaoSub(name) {
    return (
      <div>
        <Button label="Cadastrar" 
                onClick={this.adicionarTarefa}
                className="p-button-primary p-button-text"/> 
        &nbsp;
        <Button label="Cancelar" 
                className="p-button-secondary p-button-text"
                onClick={() => this.fecharModal(name)}/>
      </div>
    );
  }

  novaConfiguracao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({nome: ''});
    this.setState({tituloCriada: ''});
    this.setState({ponto: ''});
    this.setState({prazoData: ''});
    this.setState(state);
  }

  abrirSubTarefas(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirConfiguracaoAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirConsultaConfiguracao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  consultarSubTarefas(tarefa) {
    for(let i = 0; i < this.state.tarefas.length; i++) {
      if(tarefa.codigo == this.state.tarefas[i].codigo) {
        this.setState({subTarefas: this.state.tarefas[i].tarefasFilhas});
      }
    }
    this.abrirSubTarefas('modalSubTarefas');
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  async consultarConfiguracaoTarefa(configuracao) {
    this.setState({openSpinner: true});
    await this.configuracaoTarefaService.consultarConfiguracaoTarefa(configuracao.codigo)
      .then(response => {
        this.setState({tarefa: response.data});
        this.setState({tarefasFilhas: response.data.tarefasFilhas});
        this.setState({nomeConsulta: response.data.nome});
        this.consultarConfiguracoesSemTarefaCriadora(response.data.codigo, response.data.empresa.codigo);
        this.setState({configuracoesSemTarefa: null});
        this.abrirConsultaConfiguracao('modalNovaSubTarefa');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarConfiguracaoTarefaEditar(configuracao) {
    this.setState({openSpinner: true});
    await this.configuracaoTarefaService.consultarConfiguracaoTarefa(configuracao.codigo)
      .then(response => {
        this.setState({tarefa: response.data});
        this.setState({tarefasFilhas: response.data.tarefasFilhas});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.setState({tituloCriada: response.data.tituloCriada})
        this.setState({ponto: response.data.ponto});
        if(response.data.snAtivo == 'ATIVO') {
          this.setState({status: {
            codigo: 'ATIVO',
            nome: 'ATIVO'
          }})
        } else {
          this.setState({status: {
            codigo: 'INATIVO',
            nome: 'INATIVO'
          }})
        }
        this.setState({prazoData: response.data.prazoData});
        if(response.data.snCriaOutraTarefa == 'S') {
          this.setState({criaOutraTarefa: {
            codigo: 'S',
            nome: 'SIM'
          }})
        } else {
          this.setState({criaOutraTarefa: {
            codigo: 'N',
            nome: 'NÃO'
          }})
        }
        this.abrirConfiguracaoAlterar('modalAlterarConfiguracao');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  consultarConfiguracoesSemTarefaCriadora = async (codigo, empresa) => {
    await this.configuracaoTarefaService.consultarConfiguracoesSemTarefaCriadora(codigo,empresa)
      .then(response => {
        this.setState({configuracoesSemTarefas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      })
  }

  adicionarTarefa = async () => {
    if(this.state.configuracoesSemTarefa == null) {
      this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:'Informe a nova tarefa', life: 5000});
      return;
    }
    this.setState({openSpinner: true});
    await this.configuracaoTarefaService.adicionarTarefa(this.state.tarefa.codigo, this.state.configuracoesSemTarefa.codigo)
      .then(response => {
        this.consultarSubTarefasAtualiza(this.state.tarefa.codigo);
        this.consultarConfiguracoesSemTarefaCriadora(this.state.tarefa.codigo, this.state.tarefa.empresa.codigo);
        this.toast.show({severity:'success', summary: 'Configuração de Tarefa', detail:'Nova tarefa adicionada', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  consultarSubTarefasAtualiza = async (codigo) => {
    await this.configuracaoTarefaService.consultarSubTarefas(codigo)
      .then(response => {
        this.setState({tarefasFilhas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      })
  }

  desvincularTarefa = async () => {
    this.setState({openSpinner: true});
    await this.configuracaoTarefaService.desvincularTarefa(this.state.codigo)
      .then(response => {
        this.consultarSubTarefasAtualiza(this.state.codigo);
        this.toast.show({severity:'success', summary: 'Configuração de Tarefa', detail:'Terefa atualizada', life: 4000});
      }).catch(error => {
        console.log('Desvincular', error)
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarNovaConfiguracao = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:'O Nome da configuração é obrigatória', life: 4000});
      return;
    }

    if(this.state.prazoData == '' || this.state.prazoData == null) {
      this.setState({prazoData: 0});
    }

    if(this.state.ponto == '' || this.state.ponto == null) {
      this.setState({ponto: 0});
    }

    const tarefa = {
      empresa: usuarioLogado.empresa,
      nome: this.state.nome,
      tituloCriada: this.state.tituloCriada,
      ponto: this.state.ponto,
      prazoData: this.state.prazoData,
      snCriaOutraTarefa: 'N'
    };

    this.setState({openSpinner: true});
    await this.configuracaoTarefaService.cadastrarNovaTarefa(tarefa)
      .then(response => {
        this.listarTarefas();
        this.toast.show({severity:'success', summary: 'Configuração de Tarefa', detail:'Nova tarefa cadastrada com sucesso!', life: 4000});
        this.fecharModal('modalNovaConfiguracao');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Configuração de Tarefa', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarTarefas();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <Navbar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.openSpinner}>
            <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
          </Backdrop>
            <div className="container-fluid">
             <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-boxes"></i>
                        <span> Configurações de Tarefas</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    data-toggle="modal" 
                                    onClick={() => this.novaConfiguracao('modalNovaConfiguracao')}
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.tarefas}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      emptyMessage=" "
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column field="tituloCriada" header="Título Pré-definidi da tarefa"></Column>
                      <Column field="prazoData" header="Prazo"></Column>
                      <Column body={this.subTarefas} exportable={false} style={{ minWidth: '8rem' }}header="Sub-Tarefas"></Column>
                      <Column field="ponto" header="Pontos para Desempenho"></Column>
                      <Column field="snAtivo" header="Status"></Column>
                      <Column body={this.acoesTarefas} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
            {/**Cadastrar nova Tarefa */}
            <Dialog header="Nova Configuração"
                      visible={this.state.modalNovaConfiguracao} 
                      style={{ width: '40vw' }} 
                      footer={this.renderNovaConfiguracao('modalNovaConfiguracao')} 
                      onHide={() => this.fecharModal('modalNovaConfiguracao')}>
                  
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="nmConfigTarefa">Nome<span className="obrigatorioAsterisco"> *</span></label>
                    <InputText id="nmConfigTarefa" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.nome}
                          onChange={e => this.setState({nome: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="titulo">Título</label>
                    <InputText id="titulo" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.tituloCriada}
                          onChange={e => this.setState({tituloCriada: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="prazo">Prazo</label>
                    <InputText id="prazo" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.prazoData}
                          onChange={e => this.setState({prazoData: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="ponto">Pontuação</label>
                    <InputText id="ponto" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.ponto}
                          onChange={e => this.setState({ponto: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
            </Dialog>
            {/**Editar Tarefa */}
            <Dialog header="Nova Configuração"
                      visible={this.state.modalAlterarConfiguracao} 
                      style={{ width: '40vw' }} 
                      footer={this.renderAlterarConfiguracao('modalAlterarConfiguracao')} 
                      onHide={() => this.fecharModal('modalAlterarConfiguracao')}>
                  
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="nmConfigTarefaAlterar">Nome<span className="obrigatorioAsterisco"> *</span></label>
                    <InputText id="nmConfigTarefaAlterar" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.nome}
                          onChange={e => this.setState({nome: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="tituloAlterar">Título</label>
                    <InputText id="tituloAlterar" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.tituloCriada}
                          onChange={e => this.setState({tituloCriada: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="criaOutraTarefa">Cria outra Tarefa</label>
                    <Dropdown value={this.state.criaOutraTarefa} 
                              options={this.criaOutraTarefa} style={{width: '100%', height: '32px'}}
                              optionLabel="nome" 
                              emptyMessage=" "
                              filter showClear filterBy="nome"
                              onChange={e => this.setState({criaOutraTarefa: e.target.value})}
                              id="criaOutraTarefa"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="status">Status</label>
                    <Dropdown value={this.state.status} 
                              options={this.status} style={{width: '100%', height: '32px'}}
                              optionLabel="nome" 
                              emptyMessage=" "
                              filter showClear filterBy="nome"
                              onChange={e => this.setState({status: e.target.value})}
                              id="status"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="prazoAlterar">Prazo</label>
                    <InputText id="prazoAlterar" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.prazoData}
                          onChange={e => this.setState({prazoData: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="pontoAlterar">Pontuação</label>
                    <InputText id="pontoAlterar" 
                          type="text" 
                          style={{width: '100%', height: '32px'}} 
                          value={this.state.ponto}
                          onChange={e => this.setState({ponto: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
            </Dialog>
            {/**Cadastrar nova Sub-Tarefa */}
            <Dialog header="Nova Configuração"
                      visible={this.state.modalNovaSubTarefa} 
                      style={{ width: '40vw' }} 
                      footer={this.renderNovaConfiguracaoSub('modalNovaSubTarefa')} 
                      onHide={() => this.fecharModal('modalNovaSubTarefa')}>
                  
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <p>Adicione aqui tarefa que serão criadas de forma automática a partir de sua principal</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label className="labelAzul"
                           htmlFor="nmConfigTarefa">Tarefa Principal: {this.state.nomeConsulta}</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="nmConfigTarefa">Tarefas já adicionadas</label>
                    <DataTable value={this.state.tarefasFilhas}
                        emptyMessage=" "
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                        <Column field="nome" header="Nome"></Column>
                        <Column field="tituloCriada" header="Título Pré-definidi da tarefa"></Column>
                        <Column field="prazoData" header="Prazo"></Column>
                        <Column field="ponto" header="Pontos para Desempenho"></Column>
                        <Column field="snAtivo" header="Status"></Column>
                      </DataTable>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="nmConfigTarefa">Adicionar tarefa à principal</label>
                    <Dropdown value={this.state.configuracoesSemTarefa} style={{width: '100%', height: '32px'}} 
                              options={this.state.configuracoesSemTarefas} style={{width: '100%', height: '32px'}}
                              optionLabel="nome" 
                              emptyMessage=" "
                              filter showClear filterBy="nome"
                              onChange={e => this.setState({configuracoesSemTarefa: e.target.value})}
                              id="idStatusAtividade"
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
            </Dialog>
            {/**Sub-Tarefas */}
            <Dialog header="Sub-Tarefas"
                      visible={this.state.modalSubTarefas} 
                      style={{ width: '40vw' }} 
                      footer={this.renderSubTarefas('modalSubTarefas')} 
                      onHide={() => this.fecharModal('modalSubTarefas')}>
                  
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                      <DataTable value={this.state.subTarefas}  paginator responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        emptyMessage=" "
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                        <Column field="nome" header="Nome"></Column>
                        <Column field="tituloCriada" header="Título"></Column>
                        <Column field="prazoData" header="Prazo"></Column>
                        <Column field="ponto" header="Pontuação"></Column>
                        <Column field="snAtivo" header="Status"></Column>
                        <Column body={this.acoesDesvincular} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                      </div>
                    </div>
                  </div>
            </Dialog>
          </section>
        </div>
      </>
    )
  }
}
ConfiguracaoTarefa.contextType = AuthContext;
export default withRouter (ConfiguracaoTarefa)